
import { Link, useLocation } from "react-router-dom";
import { Home, Radio, Compass, Users, Settings, Menu, BookOpen } from "lucide-react";
import { useState } from "react";
import { ThemeToggle } from "./ThemeToggle";

const NavBar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  const navItems = [
    { name: "Home", path: "/", icon: <Home className="w-4 h-4 mr-2" /> },
    { name: "Shows", path: "/shows", icon: <Radio className="w-4 h-4 mr-2" /> },
    { name: "Explore", path: "/explore", icon: <Compass className="w-4 h-4 mr-2" /> },
    { name: "Manager", path: "/manager", icon: <Users className="w-4 h-4 mr-2" /> },
    { name: "Docs", path: "/docs", icon: <BookOpen className="w-4 h-4 mr-2" /> },
    { name: "Settings", path: "/settings", icon: <Settings className="w-4 h-4 mr-2" /> },
  ];
  
  return (
    <nav className="bg-background border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center py-3">
              <Link to="/" className="flex items-center">
                <img 
                  src="/lovable-uploads/d9d55f21-709c-4984-a6a6-05ded8e6ce2c.png" 
                  alt="Agent Vodka Logo" 
                  className="h-14 w-auto mr-3" 
                />
                <span className="text-xl font-bold text-foreground">Agent V</span>
              </Link>
            </div>
          </div>
          
          {/* Theme toggle and mobile menu button */}
          <div className="flex items-center gap-2">
            <ThemeToggle />
            
            {/* Mobile menu button */}
            <div className="md:hidden">
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent/50"
              >
                <Menu className="w-6 h-6" />
              </button>
            </div>
          </div>
          
          {/* Desktop navigation */}
          <div className="hidden md:flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`inline-flex items-center px-4 py-3 text-sm font-medium transition-colors
                  ${isActive(item.path) 
                    ? "border-b-2 border-primary text-primary" 
                    : "text-muted-foreground hover:text-foreground hover:bg-accent/50"
                  }`}
              >
                {item.icon}
                {item.name}
              </Link>
            ))}
          </div>
        </div>
        
        {/* Mobile navigation menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-3 animate-slide-down">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-2 my-1 text-sm font-medium transition-colors rounded
                  ${isActive(item.path) 
                    ? "bg-primary/10 text-primary" 
                    : "text-muted-foreground hover:text-foreground hover:bg-accent/50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.icon}
                {item.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
